// Constant Data for Fast Sell Payment

export const PAYMENT_STATUS = {
  PENDING   : 'pending',
  COMPLETED : 'completed'
}

export const PER_PAGE = {
  5  : '5',
  10 : '10',
  25 : '25'
}

export const SORT_BY = {
  ID             : 'id',
  PAYMENT_STATUS : 'payment_status',
  TRANSFERRED_AT : 'transferred_at',
  AMOUNT         : 'amount'
}

export const SORT_DIR = {
  ASC  : 'asc',
  DESC : 'desc'
}
